import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ConfirmationService, Message, SelectItem, TreeNode } from 'primeng/api';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { MenuVisita } from '../../_models/menu-visita';
import { MenuVisitaService } from '../../_services/menu-visita.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { MenuVisitaVinculacion } from '../../_models/menu-visita-vinculacion';
import { MenuVisitaVinculacionService } from '../../_services/menu-visita-vinculacion.service';

@Component( {
  selector: 'app-vinculacion-tercero-detalle-submenu',
  templateUrl: 'vinculacion-tercero-detalle-submenu.component.html'
} )
export class VinculacionTerceroDetalleSubmenuComponent implements OnInit {


  msg: Message;
  /**
   * lista de menús visita
   * @type {Array}
   */
  menusVisitas: MenuVisita[] = [];
  /**
   * menú visita
   * @type {MenuVisita}
   */
  menuVisita: MenuVisita;
  treeProperties: TreeNode[] = [];
  nodeSelected: TreeNode;
  menu: Funcionalidad = new Funcionalidad();
  menuVinculacion: MenuVisitaVinculacion = {} as MenuVisitaVinculacion;
  header = this.navService.buscarMensaje( 'MENUVISITA.LBL_MENU' );
  displayDialog = false;
  submitted = false;
  guardado = false;
  jsonData: any;
  loadingTree = true;
  loadingData = true;
  formulario: FormGroup;
  carInformacionInicial = true;

  constructor( private router: Router,
               private location: Location,
               private serMenuVisita: MenuVisitaService,
               private serMenuVinculacion: MenuVisitaVinculacionService,
               private navService: NavService,
               private autServicio: AutenticacionService,
               private confirmationService: ConfirmationService,
               private fb: FormBuilder,
               private serListas: ListaService,
               private route: ActivatedRoute, ) {
  }

  ngOnInit() {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/vinculacion-tercero' );
        if ( mn ) {
          this.menu = mn;
        }

        this.formulario = this.fb.group( {
          idMenuVisita: [ null ],
          idPadre: [ null ],
          nombre: [ null, [ Validators.required ] ],
          codigo: [ null, [ Validators.required ] ],
          orden: [ null ],
          indicadorHabilitado: [ null, [ Validators.required ] ]
        } );

        this.serMenuVinculacion.obtenerPorId( params[ 'id' ] ).subscribe( reg => {
          this.menuVinculacion = reg;
          this.serMenuVisita.obtenerHijos( this.menuVinculacion.idMenuVisita ).subscribe( res => {
            this.jsonData = res.children;
            this.treeProperties = this.jsonData;

            this.loadingTree = false;
            this.loadingData = false;
            this.guardado = false;

            this.carInformacionInicial = false;
          } );
        } );

      }
    } );
  }


  /**
   * volver atras
   */
  goBack(): void {
    this.location.back();
  }

  get f() {
    return this.formulario.controls;
  }

  regresar() {
    this.router.navigate( [ 'apl/vinculacion-tercero/configurar-vinculacion/' + this.menuVinculacion.idTipoVinculacion ] );
  }

}
